import { isBrandInNAM } from "@faire/help-center-self-serve/utils/isBrandInNAM";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalAccountRoute from "@faire/web-api--source/routes/brand-portal/account";
import React from "react";
import { Bold } from "../common/Bold";
import { RowWithBullet } from "../common/RowWithBullet";
export var UpdatePayoutsIA = function UpdatePayoutsIA(_ref) {
  var brand = _ref.brand;
  if (isBrandInNAM(brand)) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "gbEM9B",
      defaultMessage: [{
        "type": 0,
        "value": "Puedes elegir cuándo quieres recibir el pago después de enviar los pedidos. Los pagos se tramitan en función de la opción de pago seleccionada, pero pueden tardar de 3 a 5 días hábiles en reflejarse en tu cuenta, en función de los plazos de tramitación de tu banco. La tarifa por tramitación del pago dependerá de la opción que elijas."
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg
    /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */, {
      id: "CYGSaU",
      /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Cobro al día siguiente:"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " 3,5 % + 0,30 €"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg
    /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */, {
      id: "zaIu+A",
      /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Cobro a 30 días:"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " 2,4 % + 0,30 €"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg
    /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */, {
      id: "bZnAZH",
      /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Pago a 60 días:"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " 1,9 % + 0,30 €"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "q1sTS9",
      defaultMessage: [{
        "type": 0,
        "value": "Para cambiar la opción de pago y la tarifa por tramitación del pago correspondiente, accede a "
      }, {
        "children": [{
          "type": 0,
          "value": "Configuración de la cuenta"
        }],
        "type": 8,
        "value": "AccountSettingLinkFormatting"
      }, {
        "type": 0,
        "value": " y selecciona la pestaña "
      }, {
        "children": [{
          "type": 0,
          "value": "Pago"
        }],
        "type": 8,
        "value": "PayoutLinkFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        AccountSettingLinkFormatting: function AccountSettingLinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "my-account");
        },
        PayoutLinkFormatting: function PayoutLinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "payment");
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "oGyzWH",
      defaultMessage: [{
        "type": 0,
        "value": "Los cambios se aplicarán a todos los pedidos que se hagan después de que se actualice la configuración del pago. Contacta con nosotros para cambiar la opción de pago de los pedidos actuales."
      }]
    })));
  }
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "iMNCJo",
    defaultMessage: [{
      "type": 0,
      "value": "Puedes elegir cuándo quieres recibir el pago después de enviar los pedidos. Los pagos se tramitan en función de la opción de pago seleccionada, pero pueden tardar de 3 a 5 días hábiles en reflejarse en tu cuenta, en función de los plazos de tramitación de tu banco. La tarifa por tramitación del pago dependerá de la opción que elijas."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "3kOCho",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Pago ACH al día siguiente:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " se aplica una tarifa del 3 % tanto al pedido como a los gastos de envío."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ljpEqK",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Pago ACH a 30 días:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " no se aplica ninguna tarifa por recibir el dinero."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "S45UJf",
    defaultMessage: [{
      "type": 0,
      "value": "Para cambiar la opción de pago y la tarifa por tramitación del pago correspondiente, accede a "
    }, {
      "children": [{
        "type": 0,
        "value": "Configuración de la cuenta"
      }],
      "type": 8,
      "value": "AccountSettingLinkFormatting"
    }, {
      "type": 0,
      "value": " y selecciona la pestaña "
    }, {
      "children": [{
        "type": 0,
        "value": "Pago"
      }],
      "type": 8,
      "value": "PayoutLinkFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      AccountSettingLinkFormatting: function AccountSettingLinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "my-account");
      },
      PayoutLinkFormatting: function PayoutLinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "payment");
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "JR23KI",
    defaultMessage: [{
      "type": 0,
      "value": "Los cambios se aplicarán a todos los pedidos que se hagan después de que se actualice la configuración del pago. Contacta con nosotros para cambiar la opción de pago de los pedidos actuales."
    }]
  })));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};